'use client'

import React from 'react'
import { useLocation } from 'react-router'
import PasswordProtection from './PasswordProtection'

interface ProtectedRouteProps {
  children: React.ReactNode
  protectedPaths?: string[]
}

// Paths that require password protection
const PROTECTED_PATHS = ['/ProfessionalProjects', '/AIAgentCaseStudy', '/PromoUI', '/PromoAI', '/SupplyChainOptimization', '/StoreInventoryOperations', '/DesignMentorship', '/Resume', '/Admin', '/Process', '/About']

export default function ProtectedRoute({ children, protectedPaths = PROTECTED_PATHS }: ProtectedRouteProps) {
  const location = useLocation()
  const isProtected = protectedPaths.some(path => location.pathname === path || location.pathname.startsWith(path + '/'))

  if (isProtected) {
    return <PasswordProtection>{children}</PasswordProtection>
  }

  return <>{children}</>
}

